import script from "./CRM20_007RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM20_007RPT.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__